import React from 'react';
import { FooterLink, IFooterLinkProps } from './FooterLink';
import * as classes from './Footer.module.scss';

export interface ILegalLinksProps {
    title: string;
    items: IFooterLinkProps[];
}

export const LegalLinks: React.FunctionComponent<ILegalLinksProps> = props => {
    return (
        <div role="group" aria-label={props.title} className={classes.legalLinks}>
            {props.items.map((item, i) => (
                <FooterLink key={i} {...item} />
            ))}
        </div>
    );
};
